import React from "react";

/**
 * Замещает в строке `str` значения `Replacement.from` элементами-результатами `Replacement.to()`
 * @param str {string} строка для замещения
 * @param {Array<{from:string to:(function(): React.ReactElement)}>} replacements правила замещений
 * @param depth
 * @returns {Array<React.ElementType | string>}
 */
const interpolateReact = (str:string, replacements, depth = 0) => {
  if (depth >= replacements.length) {
    return [str];
  }

  const currentReplacement = replacements[depth];
  const parts = str.split(currentReplacement.from);

  return parts.reduce((prev, cur, index) => {
    const result = [...prev, ...interpolateReact(cur, replacements, depth + 1)];
    if (index < parts.length - 1) {
      const reactElement = React.createElement(currentReplacement.to, { key: currentReplacement.from });
      result.push(reactElement);
    }
    return result;
  }, []);
};

export default interpolateReact;
